<template>
  <div>
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-reset': !isIndex }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      @keyup.enter.native="submit('password')"
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item class="form-item-primary" prop="phone">
        <!-- 手机号码 -->
        <div class="input-custom-disabled">
          +{{ form.pretel }}&nbsp;&nbsp;{{ form.phone | phoneFormat }}
        </div>
      </el-form-item>

      <el-form-item class="form-item-primary" prop="password">
        <BaseInput
          v-model="form.password"
          type="password"
          :validate-event="Boolean(form.password)"
          :placeholer="$t('login.loginPage.passwords')"
        />
      </el-form-item>
      <el-form-item>
        <div class="change-logintype">
          <pre class="red-word" @click="changeLoginType">{{
            $t('login.loginPage.signInwithVerificationCode')
          }}</pre>
          <p class="red-word" @click="forgotPassword">
            {{ $t('login.loginPage.forgetPassword') }}
          </p>
        </div>
      </el-form-item>
    </el-form>

    <el-button
      class="button-custom"
      @click="submit('password')"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.signIn`,
      }"
      >{{ $t('login.loginPage.signIn') }}</el-button
    >
  </div>
</template>

<script>
import LoginByPhoneMixin from './../mixins/LoginByPhoneMixin'
export default {
  mixins: [LoginByPhoneMixin],
  data() {
    return {}
  },
  computed: {},

  created() {},

  methods: {
    changeLoginType() {
      this.$emit('changeLoginType', 'verificationCode')
    },
  },
}
</script>
<style lang="scss" scoped>
.login-btn-default {
  margin-top: 8px;
}
.form-custom {
  margin-top: 40px;
  margin-bottom: 40px;
}
.change-logintype {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.red-word {
  font-size: 14px;
  line-height: 20px;
  color: #f0386c;
  cursor: pointer;
  font-family: 'PingFang SC', sans-serif;
}
</style>
